export const Messages = {
    SUCCESS: 0, ERROR: 1
}
